import { Injectable } from '@angular/core';
import {  ForgotPasswordModel } from '../models/login/forgotPassword';
import { LoginModel, RegisterModel, ResendConformationModel } from '../models/login/login.model';
import { VerifyModel } from '../models/login/verify.model';
import { ChangePasswordModel } from '../models/login/changePassword.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private _api:ApiService) { }

  login(user: LoginModel)
  {
    return this._api.post(UrlHelperService.login, user);
  }
  Register(registerUser: RegisterModel)
  {
    return this._api.post(UrlHelperService.Register, registerUser);
  }
  


  forgotPassword(forgotPassword: ForgotPasswordModel)
  {
    return this._api.post(UrlHelperService.forgotPassword, forgotPassword);
  }

  verifyOtp(verifyOtp: VerifyModel)
  {
    return this._api.post(UrlHelperService.verifyOtp, verifyOtp);
  }

  changePassword(changePassword: ChangePasswordModel)
  {
    return this._api.post(UrlHelperService.changePassword, changePassword);
  }
  ResendVerification(ResendVerification:ResendConformationModel )
  {
    return this._api.post(UrlHelperService.ResendVerifications, ResendVerification);
  }
}
